import { useEffect } from "react";
import { useResourceStore } from "@shared/stores";
import { useWarningStore } from "@shared/stores/warningStore";

export const useCheckWarning = () => {
  const { selectedResource } = useResourceStore();
  const { removeWarningByRessourceId, warnings } = useWarningStore();

  useEffect(() => {
    if (warnings.length > 0) {
      warnings.forEach((warning) => {
        if (!selectedResource.some((resource) => resource.id === warning.ressourceId)) {
          removeWarningByRessourceId(warning.ressourceId ?? 0);
        }
      });
    }
  }, [selectedResource, warnings]);

  return {};
};
